import { render, staticRenderFns } from "./shanHeader.vue?vue&type=template&id=463979e6&scoped=true&"
import script from "./shanHeader.vue?vue&type=script&lang=js&"
export * from "./shanHeader.vue?vue&type=script&lang=js&"
import style0 from "./shanHeader.vue?vue&type=style&index=0&id=463979e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463979e6",
  null
  
)

export default component.exports